import { z } from "zod";

export const ObjectWithItemsSchema = z.object({
  reasoning: z
    .string()
    .describe("The reasoning behind the categorization of the content"),
  detectedContent: z
    .string()
    .describe("The detected content that led to the conclusion"),
  items: z
    .array(z.string())
    .describe("The items that were detected in the content"),
});

export type ObjectWithItems = z.infer<typeof ObjectWithItemsSchema>;

export const SummaryOutputSchema = z.object({
  internalSummary: ObjectWithItemsSchema,
  unansweredQuestions: ObjectWithItemsSchema,
  nextSteps: ObjectWithItemsSchema,
  shareableSummary: z.string(),
  salesPipelineStatus: z.enum(["lead", "qualified", "closing", "closed"]),
});

export type SummaryOutput = z.infer<typeof SummaryOutputSchema>;
